import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CardIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CardIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M19.4683 19.3428H4.53223C3.13575 19.3428 2 18.207 2 16.811V7.18946C2 5.79298 3.13574 4.65723 4.53223 4.65723H19.4683C20.8643 4.65723 22 5.79297 22 7.18946V16.811C22 18.207 20.8643 19.3428 19.4683 19.3428ZM4.53223 5.65723C3.6875 5.65723 3 6.34473 3 7.18946V16.811C3 17.6558 3.6875 18.3428 4.53223 18.3428H19.4683C20.313 18.3428 21 17.6558 21 16.811V7.18946C21 6.34473 20.313 5.65723 19.4683 5.65723H4.53223Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.5 12.4336H2.5293C2.25293 12.4336 2.0293 12.21 2.0293 11.9336V8.47901C2.0293 8.20264 2.25293 7.97901 2.5293 7.97901H21.5C21.7764 7.97901 22 8.20264 22 8.47901V11.9336C22 12.21 21.7764 12.4336 21.5 12.4336ZM3.0293 11.4336H21V8.97901H3.0293V11.4336Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.68213 16.1538H5.82178C5.54541 16.1538 5.32178 15.9302 5.32178 15.6538C5.32178 15.3774 5.54541 15.1538 5.82178 15.1538H7.68213C7.9585 15.1538 8.18213 15.3774 8.18213 15.6538C8.18213 15.9302 7.9585 16.1538 7.68213 16.1538Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.5913 16.1538H10.605C10.3286 16.1538 10.105 15.9302 10.105 15.6538C10.105 15.3774 10.3286 15.1538 10.605 15.1538H14.5913C14.8677 15.1538 15.0913 15.3774 15.0913 15.6538C15.0913 15.9302 14.8677 16.1538 14.5913 16.1538Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CardIcon;
